export const fetchAuthToken = async () => {
  // Skip if no auth URL
  if (!process.env.REACT_APP_BASE_URL) {
    console.warn("No base URL set");
    return null;
  }
  if (
    !process.env.REACT_APP_AUTH_CLIENT ||
    !process.env.REACT_APP_AUTH_SECRET
  ) {
    console.warn("Missing auth credentials");
    return null;
  }

  try {
    let headers = new Headers();
    headers.set(
      "Authorization",
      "Basic " +
        btoa(
          `${process.env.REACT_APP_AUTH_CLIENT}:${process.env.REACT_APP_AUTH_SECRET}`
        )
    );
    headers.set("Content-Type", "application/x-www-form-urlencoded");

    const res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/auth/get-access-token`,
      {
        method: "POST",
        headers: headers,
        body: "grant_type=client_credentials",
      }
    );

    if (!res.ok) {
      console.error(`Token fetch failed: ${res.status} ${res.statusText}`);
      return null;
    }

    const response = await res.json();
    return response.access_token;
  } catch (error) {
    console.error("Token fetch error:", error.message);
    return null;
  }
};
